import ComponentRegistry from '../../model/ComponentRegistry';
import PreLoginHome from './../common/PreloginHome';
import '../../css/prelogin/contest.css';

export default class ContestPreLoginHome extends PreLoginHome{
	
	//Overriding this to prevent unnecessary ajax calls
	componentDidMount(){

	}

}

ComponentRegistry.register("Contest_PreLoginHome", ContestPreLoginHome);


// WEBPACK FOOTER //
// ./src/views/contest/ContestPreLoginHome.js